export default "__VITE_ASSET__DMHGj0gt__"